// components/ui/ReportMasthead.tsx
// Boxed document masthead for the printable report.
// 2px ink top-rule, 1px sides/bottom, wordmark + definition-list metadata.
//
// Note: prop renamed from `ref` (handoff spec) to `caseRef` to avoid
// colliding with React's reserved `ref` prop on function components.

import React from 'react';

interface ReportMastheadProps {
    caseRef?: string;          // '2026-04-HOL-0412'
    preparedAt?: string;       // '20 April 2026 · 14:02'
    preparedFor?: string;      // 'Ms E. Holloway (executor)'
}

export function ReportMasthead({ caseRef, preparedAt, preparedFor }: ReportMastheadProps) {
    return (
        <div className="report-masthead grid grid-cols-[1fr_auto] gap-x-8 gap-y-3.5 items-start
                        border border-[#E8E4DB] border-t-2 border-t-[#1A1A1A]
                        bg-[#FAFAF8] p-[18px_22px] mb-8">
            <div>
                <div className="font-serif text-[18px] text-[#1A1A1A]">
                    Estate<span className="italic">clarity</span>
                </div>
                <div className="text-[10px] tracking-[0.16em] uppercase text-[#6B6762] mt-0.5">
                    Probate &amp; IHT review
                </div>
            </div>
            <dl className="grid grid-cols-[auto_auto] gap-x-3.5 gap-y-1 text-[11px] leading-[1.4] m-0 self-start">
                {caseRef && <>
                    <dt className="text-[9px] tracking-[0.16em] uppercase text-[#6B6762] self-center m-0">Ref.</dt>
                    <dd className="font-mono text-[12px] text-[#1A1A1A] font-medium tracking-[0.02em] m-0">{caseRef}</dd>
                </>}
                {preparedAt && <>
                    <dt className="text-[9px] tracking-[0.16em] uppercase text-[#6B6762] self-center m-0">Prepared</dt>
                    <dd className="text-[12px] text-[#1A1A1A] font-medium m-0">{preparedAt}</dd>
                </>}
                {preparedFor && <>
                    <dt className="text-[9px] tracking-[0.16em] uppercase text-[#6B6762] self-center m-0">For</dt>
                    <dd className="text-[12px] text-[#6B6762] m-0">{preparedFor}</dd>
                </>}
            </dl>
        </div>
    );
}
